import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom'
import {
  Grid,
  Segment,
} from 'semantic-ui-react';
import CheckoutError from './CheckoutError.js';
import Download from './Download.js';
import Asset from './Asset.js';
import Logo from './Logo.js';
import Preview from './Preview.js';
import Selector from './Selector.js';

class Main extends Component {
  render() {
    return (
      <div style={style.main}>
        <Grid>
          <Segment textAlign='center'>
            <Switch>
              <Route exact path='/' component={Selector}/>
              <Route path='/tool/logo' component={Logo}/>
              <Route path='/tool/:asset' component={Asset}/>
              <Route path='/preview/:type/:uid/:thumb' component={Preview}/>
              <Route path='/checkout/error/:uid?' component={CheckoutError} />
              <Route path='/download/:type/:uid' component={Download}/>
            </Switch>
          </Segment>
        </Grid>
      </div>
    );
  }
}

const style = {
  main: {
    padding: '2em',
    paddingTop: '5em',
  },
}

export default Main;



// WEBPACK FOOTER //
// ./src/Main.js